import { apiInstance, gql } from "@/services/httpAdapter";

export async function deleteSalesPerformanceReportVersion(locationId, id) {
	const query = gql`
		mutation deleteSalesPerformanceReportVersion($locationId: String!, $id: String!) {
			deleteSalesPerformanceReportVersion(locationId: $locationId, id: $id)
		}
	`;

	const variables = {
		locationId: locationId,
		id: id,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.deleteSalesPerformanceReportVersion;
	} catch (err) {
		console.error(err);
		return null;
	}
}

export async function updateSalesPerformanceReportVersion(model) {
	const query = gql`
		mutation updateSalesPerformanceReportVersion($input: SalesPerformanceReportVersionUpdate) {
			updateSalesPerformanceReportVersion(input: $input) {
				_id
				locationId
				title
				effectiveDateTime
				saleDate
				saleAmount
				dealNumber
				customerName
				customerNumber
				stockNumber
				description
				saleType
				dealType
				units
				salesEmployeeId
				financeEmployeeId
				salesManagerId
				frontProducts {
					_id
					label
					reportField
					contractUnits
				}
				backProducts {
					_id
					label
					reportField
					contractUnits
				}
				createdOn
				createdBy
				lastModifiedOn
				lastModifiedBy
				locked
				datePeriods {
					startDate
				}
			}
		}
	`;

	const variables = {
		input: model,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateSalesPerformanceReportVersion;
	} catch (err) {
		console.error(err);
		return null;
	}
}
